/*
 * Copyright (c) 2012 Mathieu Turcotte
 * Licensed under the MIT license.
 */

module.exports = require('./lib/checks');


// WEBPACK FOOTER //
// ./node_modules/precond/index.js